function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#333331;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Dark_Grey_Shizzz",
  "data-name": "Dark Grey Shizzz"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "201.51 139.75 269.01 127.19 200.59 121.41 262.21 91.1 194.76 104 245.92 58.19 184.45 88.8 221.35 30.89 170.43 76.95 190.33 11.24 153.72 69.33 155.16 0.68 135.58 66.49 118.44 0 117.35 68.66 82.91 9.25 100.38 75.66 51.18 27.75 85.92 86.98 25.63 54.12 75.06 101.79 8.13 86.41 68.59 118.97 0 122.22 67 137.26 1.83 158.9 70.4 155.31 13.49 193.72 78.55 171.76 34.11 224.11 90.83 185.41 62.16 247.81 106.34 195.24 95.57 263.06 123.93 200.52 131.85 268.73 142.28 200.86 168.32 264.4 160.05 196.23 202.26 250.39 175.91 186.98 231.17 227.75 188.69 173.79 252.9 198.14 197.44 157.65 265.83 163.77 201.51 139.75"
})));

var SvgBurst = function SvgBurst(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 269.01 268.73",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBurst, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Burst.ac507f6b.svg";
export { ForwardRef as ReactComponent };